import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getGuestAuditLog = get('guest.auditLog');

export const getAll = createSelector(getGuestAuditLog, get('all'));

export const getMeta = createSelector(getGuestAuditLog, get('meta'));

export const getIsFetching = createSelector(getGuestAuditLog, get('fetching'));

export const getIsFetched = createSelector(getGuestAuditLog, get('fetched'));
